<template>
  <v-select
    :items="modelStatuses"
    item-text="text"
    item-value="value"
    dense
    @input="modelStatusChange(model.id, model.config ? true : false, $event)"
    :value="model.model_status ? model.model_status : 'Testing'"
  >
    <template v-slot:item="{ item }">
      <v-chip
        class="mr-2"
        :color="modelStatusColor(item.value)"
        text-color="white"
        small
      >
        {{ item.text }}
      </v-chip>
    </template>
    <template v-slot:selection="{ item }">
      <v-chip
        class="mr-2"
        :color="modelStatusColor(item.value)"
        text-color="white"
        small
      >
        {{ item.text }}
      </v-chip>
    </template>
  </v-select>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      modelStatusColors: {
        Testing: 'orange',
        Ready: 'green',
        Deployed: 'blue',
        Obsolete: 'red'
      }
    }
  },
  computed: {
    modelStatuses () {
      return [
        { value: 'Testing', text: this.$t('components.ModelStatus.testing') },
        { value: 'Ready', text: this.$t('components.ModelStatus.ready') },
        { value: 'Deployed', text: this.$t('components.ModelStatus.deployed') },
        { value: 'Obsolete', text: this.$t('components.ModelStatus.obsolete') }
      ]
    }
  },
  methods: {
    ...mapActions('admin', [
      'updateModelStatus'
    ]),
    modelStatusColor (modelStatus) {
      if (modelStatus) {
        if (this.modelStatusColors[modelStatus]) {
          return this.modelStatusColors[modelStatus]
        } else {
          console.log('Error. Invalid model_status: ', modelStatus)
          return 'black'
        }
      } else {
        // Base case. All older models are classified as "Testing"
        return 'orange'
      }
    },
    modelStatusChange (modelId, modelHasConfig, newStatus) {
      this.updateModelStatus({
        modelCollectionPath: modelHasConfig ? 'reference_models' : 'clients',
        modelId: modelId,
        newStatus: newStatus
      })
    }
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>
